import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import React from 'react';
import { socialNetworksSvg } from '../../../../constants/socialNetworks';
import styleRules from '../styles';

const useStyles = makeStyles((theme) => createStyles(styleRules(theme)));

const SocialNetworks: React.FunctionComponent = () => {
  const { snIcon } = useStyles();

  return (
    <>
      {socialNetworksSvg.map((network) => {
        return (
          <Button className={snIcon} key={network.title} href={network.uri}>
            <network.icon />
          </Button>
        );
      })}
    </>
  );
};

export default SocialNetworks;
